import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { AuthProvider } from '@/auth/AuthProvider';
import { Splash } from '@/components/Splash';
import { ToastProvider } from '@/components/Toast';
import { makeQueryClient } from '@/lib/queryClient';
import { routes } from './routes';

const router = createBrowserRouter(routes);

export function App() {
  const [client] = useState(makeQueryClient);
  return (
    <QueryClientProvider client={client}>
      <ToastProvider>
        <AuthProvider>
          <Suspense fallback={<Splash />}>
            <RouterProvider router={router} />
          </Suspense>
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
